
import { useLazyQuery, useQuery } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { CgWebsite } from "react-icons/cg";
import { FaCity, FaMapMarkedAlt, FaMapPin, FaPhone, FaRegAddressCard } from "react-icons/fa";
import { Link } from "react-router";
import { Button, Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import svgSortAsc from "../../svgs/arrow-up.svg";
import svgEdit from '../../svgs/edit.svg';
import { GET_ALL_COMPANIES_FIRM_QUERY, GET_COMPANY_FIRM_QUERY } from "../Graphql/CompanyQueries/allCompanyQuery";
import Icon from "../Icon/Icon";
import Alert from "../Alert/Alert";
import MergeIcon from "@mui/icons-material/Merge";

const Company = () => {
  const [selectedCategory, setSelectedCategory] = useState("Firms");
  const [currentIndex, setCurrentIndex] = useState({
    Firms: 0
  });
  const [showAll, setShowAll] = useState({ firms: false });
  const [currentPage, setCurrentPage] = useState(1);
  const [contactsData, setContactsData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const token = localStorage.getItem("authToken");
  const [isLoadingCategory, setIsLoadingCategory] = useState(true);
  const [selectedLetter, setSelectedLetter] = useState(null);
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

  useEffect(() => {
    // Dynamically load Bootstrap CSS
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css";
    document.head.appendChild(link);

    return () => {
      // Remove Bootstrap CSS when the component unmounts
      document.head.removeChild(link);
    };
  }, []);

  const { loading, error, data } = useQuery(GET_ALL_COMPANIES_FIRM_QUERY, {
    variables: {
      pageOptions: {
        pageSize: 12,
        page: 1
      }
    }, // Adjust the limit if necessary
    fetchPolicy: "no-cache",
    context: {
      headers: {
        authorization: `Bearer ${token}`,
      },
    },
  });

  const [fetchContactsByType, { loading: typeLoading, error: typeError }] = useLazyQuery(
    GET_COMPANY_FIRM_QUERY,
    {

      fetchPolicy: "no-cache",
      context: {
        headers: {
          authorization: `Bearer ${token}`,
        },
      },
      onCompleted: (fetchedData) => {
        setContactsData(fetchedData.getCompanies.data);
        setTotalCount(fetchedData.getCompanies.totalCount);
        setIsLoadingCategory(false); // Stop spinner
      },
    }
  );


  useEffect(() => {
    if (selectedCategory !== "All") {
      fetchContactsByType({
        variables: {
          type: "Firm",
          startsWith: selectedLetter,
          pageOptions: {
            page: currentPage,
            pageSize: 52,
          },
        },
      });
    }
  }, [selectedCategory, currentPage, selectedLetter]);

  const handleDropdownChange = (event) => {
    setSelectedLetter(null);
    setIsLoadingCategory(true)
    setSelectedCategory(event.target.value);
    setCurrentPage(1); // Reset page number on category change
  };
  const handleLetterClick = (letter) => {
    if (letter === selectedLetter) {
      setSelectedLetter(null);
    } else {
      setSelectedLetter(letter);
    }
    setCurrentPage(1);
    // if(currentPage === 1){
    //   fetchContactsByType({
    //     variables: {
    //       type: "Firm",
    //       startsWith:letter === selectedLetter? null :letter,
    //       pageOptions: {
    //         page: 1,
    //         pageSize: 52,
    //       },
    //     },
    //   });
    // }
  };
  const handleNavigation = (type, direction) => {
    const maxIndex = Math.ceil((data.getAllCompanies[type.toLowerCase()] && data.getAllCompanies[type.toLowerCase()].length || 0) / 4) - 1;
    setCurrentIndex((prev) => {
      const nextIndex =
        direction === "next"
          ? Math.min(prev[type] + 1, maxIndex)
          : Math.max(prev[type] - 1, 0);
      return { ...prev, [type]: nextIndex };
    });
  };

  const getAddress = (item) => {
    return item.address || item.company_address || "N/A";
  };
  const handleShowMore = (type) => {
    // setShowAll((prev) => ({ ...prev, [type]: true }));
    // setSelectedCategory(`${type}`);
    setSelectedCategory(type);
    setCurrentPage(1);
  };

  // New method for pagination when selectedCategory !== "All"
  const handlePageChange = (direction) => {
    setCurrentPage((prevPage) =>
      direction === "next" ? prevPage + 1 : Math.max(prevPage - 1, 1)
    );
  };

  const handleListView = (type) => {
    const url = `${location.origin}/company/${(type.replace("_", "-")).toLowerCase()}`;
    window.location.href = url;
    sessionStorage.setItem("isCrm", "true");
  };

  const renderCards = (data, type) => {
    const start = currentIndex[type] * 4;
    const end = showAll[type] ? data.length : start + 4;
    const urlType = type.toLowerCase().slice(0, -1);
    const visibleCards = data.slice(start, end);
    const currentSearch = window.location.search;
    const currentPath = window.location.pathname + currentSearch;
    return (
      <Row className="mb-3">
        {visibleCards.map((item, index) => (
          <Col sm="3" key={`${type}-${index}`}>
            <Card>
              <CardHeader
                style={{ borderBlockColor: "#90C54B", color: "green" }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span
                    title={item.name}
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "70%",
                    }}
                  >
                    {item.name || "N/A"}
                  </span>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    {/* Merge Icon Link */}
                    <Link
                      to={{
                        pathname: `${arc.path.base}merging/company/${item.name}`,
                      }}
                      style={{
                        cursor: "pointer",
                        fontSize: "20px",
                        color: "rgb(100, 100, 100)",
                        backgroundColor: "transparent",
                        border: "none",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        textDecoration: "none",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget
                          .querySelectorAll("svg path")
                          .forEach((path) => {
                            path.setAttribute("fill", "#90c54b");
                          });
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget
                          .querySelectorAll("svg path")
                          .forEach((path) => {
                            path.setAttribute("fill", "#939393");
                          });
                      }}
                    >
                      <MergeIcon />
                    </Link>

                    {/* Edit Icon Link */}
                    <Link
                      to={{
                        // pathname: `${arc.path.base}${urlType}/${item.company_id}`,
                        pathname: `${arc.path.base}${urlType}/${item.company_id}`,
                        state: { fromListUrl: currentPath }
                      }}
                      style={{
                        cursor: "pointer",
                        fontSize: "20px",
                        color: "rgb(100, 100, 100)",
                        backgroundColor: "transparent",
                        border: "none",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        textDecoration: "none",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget
                          .querySelector("svg path:nth-child(2)")
                          .setAttribute("fill", "#90c54b");
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget
                          .querySelector("svg path:nth-child(2)")
                          .setAttribute("fill", "#939393");
                      }}
                    >
                      <Icon svg={svgEdit} />
                    </Link>
                  </div>
                </div>
              </CardHeader>
              <CardBody style={{ height: "128px", paddingRight: "8px" }}>
                {/* Phone */}
                <p style={{ display: "flex", alignItems: "center", margin: "3px 0", lineHeight: "1.2" }}>
                  <FaPhone
                    style={{
                      marginRight: "6px",
                      transform: "rotate(90deg)",
                      fontSize: "14px",
                      color: "gray",
                    }}
                  />
                  <span
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "85%",
                    }}
                  >
                    {item.phone || "N/A"}
                  </span>
                </p>

                {/* Address */}
                <p style={{ display: "flex", alignItems: "center", margin: "3px 0", lineHeight: "1.2" }}>
                  <FaRegAddressCard
                    style={{
                      marginRight: "6px",
                      fontSize: "14px",
                      color: "gray",
                    }}
                  />
                  <span
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "85%",
                    }}
                  >
                    {item.address || "N/A"}
                  </span>
                </p>

                {/* Website */}
                <p style={{ display: "flex", alignItems: "center", margin: "3px 0", lineHeight: "1.2" }}>
                  <CgWebsite
                    style={{
                      marginRight: "6px",
                      fontSize: "14px",
                      color: "gray",
                    }}
                  />
                  <span
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "85%",
                    }}
                  >
                    {item.website || "N/A"}
                  </span>
                </p>
              </CardBody>

            </Card>
          </Col>
        ))}
      </Row>
    );
  };

  const renderAllCards = (data, type) => {
    // const start = currentIndex[type] * 4;
    // const end = showAll[type] ? data.length : start + 4;
    const urlType =  type.toLowerCase().slice(0, -1);
    const currentSearch = window.location.search;
    const currentPath = window.location.pathname + currentSearch;
    // const visibleCards = data.slice(start, end);
    if (isLoadingCategory) {
      return <div className="spinner-border text-success" role="status" style={{ marginLeft: '16px' }}><span className="visually-hidden">Loading...</span></div>;
    }

    if (data.length === 0) {
      return <div className="errorcenter">
        <Alert type='error'>No company found for {type.toLowerCase() === "firms" ? "Company" : type}.</Alert>
      </div>;
    }
    // setIsLoadingCategory(false)
    return (
      <Card style={{ padding: "16px", marginTop: "16px", marginLeft: "16px" }}>
        <div>
          <Row className="mb-3" style={{ margin: "8px" }}>
            {data.map((item, index) => (
              <Col sm="3" key={`${type.toLowerCase() === "firms" ? "Company" : type}-${index}`} style={{ padding: "8px" }}>
                <Card>
                  <CardHeader style={{ background: "#90C54B", color: "white" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <span
                        title={item.name} // Tooltip now applies only to the name
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "70%", // Adjust based on your design
                        }}
                      >
                        {item.name || "N/A"}
                      </span>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        {/* Merge Icon Link */}
                        <Link
                          to={{
                            pathname: `${arc.path.base}merging/company/${item.name}`,
                          }}
                          style={{
                            cursor: "pointer",
                            fontSize: "20px",
                            color: "rgb(100, 100, 100)",
                            backgroundColor: "transparent",
                            border: "none",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            textDecoration: "none",
                          }}
                        >
                          <MergeIcon />
                        </Link>

                        {/* Edit Icon Link */}
                        <Link
                          to={{
                            // pathname: `${arc.path.base}${urlType}/${item.company_id}`,
                            pathname: `${arc.path.base}${urlType}/${item.company_id}`,
                            state: { fromListUrl: currentPath }
                          }}
                          style={{
                            cursor: "pointer",
                            fontSize: "20px",
                            color: "rgb(100, 100, 100)",
                            backgroundColor: "transparent",
                            border: "none",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            textDecoration: "none",
                          }}
                        >
                          <Icon svg={svgEdit} />
                        </Link>
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody style={{ height: "auto", padding: "12px", paddingRight: "8px" }}>
                    {/* Phone */}
                    <p style={{ display: "flex", alignItems: "center", margin: "3px 0", lineHeight: "1.2" }}>
                      <FaPhone
                        style={{
                          marginRight: "6px",
                          transform: "rotate(90deg)",
                          fontSize: "14px",
                          color: "gray",
                        }}
                      />
                      <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "85%" }}>
                        {item.phone || "N/A"}
                      </span>
                    </p>

                    {/* Website */}
                    <p style={{ display: "flex", alignItems: "center", margin: "3px 0", lineHeight: "1.2" }}>
                      <CgWebsite
                        style={{
                          marginRight: "6px",
                          fontSize: "14px",
                          color: "gray",
                        }}
                      />
                      <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "85%" }}>
                        {item.website || "N/A"}
                      </span>
                    </p>

                    {/* Address */}
                    <p style={{ display: "flex", margin: "10px 0", lineHeight: "1.2" }}>
                      <FaRegAddressCard
                        style={{
                          marginTop:"3px",
                          marginRight: "6px",
                          fontSize: "14px",
                          color: "gray",
                          verticalAlign: "top"
                        }}
                      />
                      <span style={{ display: "inline-block", maxWidth: "85%" }}>
                      <span
                        title={getAddress(item)}
                        style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "85%" }}
                      >
                        {getAddress(item).length > 25 ? getAddress(item).slice(0, 25) + "..." : getAddress(item)}
                      </span>
                      <span style={{ display: "block", color: "#555", fontSize: "14px" }}>
                      {(item.city || "N/A")}, {(item.state || "N/A")}{" "}
                      {(item.zip || "N/A")}
                    </span>
                      </span>
                    </p>

                    

                    {/* Company City */}
                    {/* <p style={{ display: "flex", alignItems: "center", margin: "3px 0", lineHeight: "1.2" }}>
                      <FaCity
                        style={{
                          marginRight: "6px",
                          fontSize: "14px",
                          color: "gray",
                        }}
                      />
                      <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "85%" }}>
                        {item.city || "N/A"}
                      </span>
                    </p> */}

                    {/* Company State */}
                    {/* <p style={{ display: "flex", alignItems: "center", margin: "3px 0", lineHeight: "1.2" }}>
                      <FaMapMarkedAlt
                        style={{
                          marginRight: "6px",
                          fontSize: "14px",
                          color: "gray",
                        }}
                      />
                      <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "85%" }}>
                        {item.state || "N/A"}
                      </span>
                    </p> */}

                    {/* Company Zip */}
                    {/* <p style={{ display: "flex", alignItems: "center", margin: "3px 0", lineHeight: "1.2" }}>
                      <FaMapPin
                        style={{
                          marginRight: "6px",
                          fontSize: "14px",
                          color: "gray",
                        }}
                      />
                      <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "85%" }}>
                        {item.zip || "N/A"}
                      </span>
                    </p> */}
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
          {selectedCategory !== "All" && (
            <div
              style={{
                marginTop: "8px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div style={{ display: "flex", gap: "8px", marginLeft: "16px" }}>
                <button
                  className="button-new negative"
                  onClick={() => handlePageChange("prev")}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
                <button
                  className="button-new positive"
                  onClick={() => handlePageChange("next")}
                  disabled={contactsData.length < 52}
                >
                  Next
                </button>
                <span style={{ marginTop: "7px" }}>
                  Showing{" "}
                  <strong>
                    {currentPage === 1
                      ? `1-${Math.min(52, totalCount)}`
                      : `${(currentPage - 1) * 52 + 1}-${Math.min(
                        currentPage * 52,
                        totalCount
                      )}`}
                  </strong>{" "}
                  of <strong>{totalCount}</strong>
                </span>
              </div>
            </div>
          )}
        </div>
      </Card>
    );
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#fff"
        }}
      >
        <div className="spinner-border text-success" role="status" style={{ marginTop: "23%" }}>
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) return <div className="errorcenter">
    <Alert type='error'>Error:{error.message}</Alert>
  </div>;

  const apiData = {
    Firms: data.getAllCompanies.firms || []
  };
  const handleBackClick = () => {
    setSelectedLetter(null);
    if (selectedCategory !== "All") {
      setSelectedCategory("All");
    }
    else if (selectedCategory === "All") {
      return;
    }
    else {
      history.back();
    }
  };
  return (
    <div className="CRUD">
      <div className="CRUD_content">
        <div
          className="d-flex"
          style={{ position: "relative", justifyContent: "space-between" }}
        >
          {/* <div className="page-title" style={{ marginLeft: "40px" }}>
              Contacts
            </div> */}
          <div
            className="page-back-button"
            style={{
              padding: "20px",
              marginLeft: "26px",
              // color: selectedCategory === "All" ? "black" : "#90C54B",
              color: "black",
              fontSize: "1.25rem",
            }}
          // onClick={handleBackClick}
          >
            {/* {selectedCategory === "All" ? "" : <Icon svg={svgSortAsc} />} */}
            {/* {selectedCategory === "All" ? "" : <Icon svg={svgSortAsc} />} */}
            Companies
            <button style={{
              width: "auto",
              marginLeft: "26px",
              padding: "8px 16px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
              className="button-new positive"
              onClick={() => {
                const url = `${location.origin}/merging/company`;
                window.location.href = url;
              }}
            >
              <MergeIcon />
              <span>Merge Duplicate</span>
            </button>
          </div>
          <div className="" style={{ padding: "20px 54px 0px" }}>
            {/* <select
              className="select-sampletable"
              onChange={handleDropdownChange}
              value={selectedCategory}
              style={{cursor:"pointer"}}
              disabled
            >
              <option value="All">{selectedCategory.toLowerCase() === "firm" ? "Company" : selectedCategory}</option>
              {Object.keys(apiData).map((category) => (
                <option key={category} value={category}>
                  {category.toLowerCase() === "firms" ? "Company" : category.charAt(0).toUpperCase() +
                    category.slice(1).replace("_", " ")}
                </option>
              ))}
            </select> */}
          </div>
        </div>
        <div className="page-header-container list" style={{ padding: "0px" }}>
          {/* <div
            className="page-header list"
            style={{ position: "relative", justifyContent: "space-between" }}
          >
            <div className="page-title" style={{ marginLeft: "40px" }}>
              Company
            </div>
            <div className="dropdown-container">
              <select onChange={handleDropdownChange} value={selectedCategory}>
                <option value="All">All</option>
                {Object.keys(apiData).map((category) => (
                  <option key={category} value={category}>
                    {category.charAt(0).toUpperCase() + category.slice(1).replace("_", " ")}
                  </option>
                ))}
              </select>
            </div>
          </div> */}
          <div className="line" />
        </div>
        <div className="page-body-container crud">
          <Container style={{ marginLeft: "-25px", maxWidth: "1245px" }}>
            {/* {selectedCategory === "All" ? (
              <Card
                style={{
                  padding: "16px",
                  marginTop: "16px",
                  marginLeft: "16px",
                }}
              >
                {Object.keys(apiData).map((category) => (
                  <div key={category}>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        <h5 className="me-3">
                          {category.toLowerCase() === "firms" ? "Company" : category.replace("_", " ").toUpperCase()}
                        </h5>
                        <Button
                          // className="button-new positive"
                          style={{
                            width: "76px",
                            padding: "2px",
                            marginBottom: "0.5rem",
                            backgroundColor: "#90C54B",
                            transition: "box-shadow 0.3s ease-in-out", // Smooth transition for hover effect
                          }}
                          onMouseEnter={(e) => (e.target.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.2)")}
                          onMouseLeave={(e) => (e.target.style.boxShadow = "none")}
                          onClick={() => handleListView(category)}
                        >
                          List View
                        </Button>
                      </div>
                      <div>
                        <Button
                        style={{
                          backgroundColor: "#90C54B",
                          marginRight: "1px",
                          transition: "box-shadow 0.3s ease-in-out", // Smooth transition for hover effect
                        }}
                        onMouseEnter={(e) => (e.target.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.2)")}
                        onMouseLeave={(e) => (e.target.style.boxShadow = "none")}
                          onClick={() => handleNavigation(category, "prev")}
                          disabled={currentIndex[category] === 0}
                        >
                          &lt;
                        </Button>
                        <Button
                            style={{
                              backgroundColor: "#90C54B",
                              marginRight: "1px",
                              transition: "box-shadow 0.3s ease-in-out", // Smooth transition for hover effect
                            }}
                            onMouseEnter={(e) => (e.target.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.2)")}
                            onMouseLeave={(e) => (e.target.style.boxShadow = "none")}
                          onClick={() => handleNavigation(category, "next")}
                          disabled={
                            showAll[category] ||
                            currentIndex[category] >=
                              Math.ceil(apiData[category].length / 4) - 1
                          }
                        >
                          &gt;
                        </Button>
                        {!showAll[category] &&
                          currentIndex[category] ===
                            Math.ceil(apiData[category].length / 4) - 1 && (
                            <Button
                            style={{
                              backgroundColor: "#90C54B",
                              marginRight: "1px",
                              transition: "box-shadow 0.3s ease-in-out", // Smooth transition for hover effect
                            }}
                            onMouseEnter={(e) => (e.target.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.2)")}
                            onMouseLeave={(e) => (e.target.style.boxShadow = "none")}
                              onClick={() => handleShowMore(category)}
                            >
                              {">>"}
                            </Button>
                          )}
                      </div>
                    </div>
                    {renderCards(apiData[category], category)}
                  </div>
                ))}
              </Card>
            ) :  */}

            <div key={selectedCategory}>
              <div
                className="d-flex justify-content-flex-start align-items-center"
                style={{ marginTop: "4px" }}
              >
                {/* <h5 style={{ marginLeft: "16px" }}>
                    {selectedCategory.toLowerCase() === "firm" ? "Company" : selectedCategory.replace("_", " ").toUpperCase()}
                  </h5> */}
                <Button
                  // className="button-new positive"
                  style={{
                    width: "76px",
                    padding: "2px",
                    marginLeft: "8px",
                    marginRight: "16px", // Adjust this if needed
                    // marginBottom: "-0.5rem",
                    backgroundColor: "#90C54B",
                    transition: "box-shadow 0.3s ease-in-out", // Smooth transition for hover effect
                  }}
                  onMouseEnter={(e) => (e.target.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.2)")}
                  onMouseLeave={(e) => (e.target.style.boxShadow = "none")}
                  onClick={() => handleListView(selectedCategory)}
                >
                  List View
                </Button>
                {/* Alphabet Buttons */}
                <div className="d-flex flex-wrap" style={{ marginLeft: "10px" }}>
                  {alphabet.map((letter) => (
                    <Button
                      key={letter}
                      style={{
                        margin: "2px",
                        padding: "4px 8px",
                        backgroundColor: selectedLetter === letter ? "#90C54B" : "#ccc",
                        color: "#fff",
                        border: "none",
                        transition: "0.3s",
                      }}
                      onClick={() => handleLetterClick(letter)}
                    >
                      {letter}
                    </Button>
                  ))}
                </div>
              </div>
              {renderAllCards(contactsData, selectedCategory)}
            </div>

            {/* } */}
          </Container>
        </div>
      </div>
    </div>
  );
};



export default Company;


